export const APP_CONFIG = {
  NAME: "EuCalls",
  DESCRIPTION: "European Funding Calls Platform",
  DEFAULT_PAGE_SIZE: 10,
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  SUPPORTED_FILE_TYPES: ["pdf", "doc", "docx", "txt"],
} as const;

export const ROUTES = {
  HOME: "/",
  CALLS: "/calls",
  CALLS_FOR_YOU: "/calls/for-you",
  MY_CALLS: "/calls/my-calls",
  CALL_DETAIL: "/calls/:id",
  PARTNERS: "/partners",
  PARTNERS_ORGANIZATIONS: "/partners/organizations",
  PARTNERS_MEMBERS: "/partners/members",
  PARTNERS_MY_NETWORK: "/partners/my-network",
  USER_DETAILS: "/users/:id",
  IDEAS: "/ideas",
  IDEAS_MY_IDEAS: "/ideas/my-ideas",
  IDEAS_DETAIL: "/ideas/:id",
  IDEAS_EDIT: "/idea-edit/:id",
  GOALS: "/goals",
  PROFILE: "/profile",
  LOGIN: "/login",
  REGISTER: "/register",
  SETTINGS: "/settings",
  // ✅ Settings tab routes
  SETTINGS_PROFILE: "/settings/profile",
  SETTINGS_ACCOUNT: "/settings/account",
  SETTINGS_NOTIFICATIONS: "/settings/notifications",
  SETTINGS_ORGANIZATION: "/settings/organization",
  SETTINGS_ORGANIZATION_INFO: "/settings/organization/info",
  SETTINGS_ORGANIZATION_TEAM: "/settings/organization/team",
  SETTINGS_SUBSCRIPTION: "/settings/subscription",
  SETTINGS_SUBSCRIPTION_SUCCESS: "/settings/subscription/success",
  SETTINGS_SUBSCRIPTION_FAIL: "/settings/subscription/fail",
  SETTINGS_BILLING: "/settings/billing",
  PARTNER_DETAILS: "/partner/:id",
  SIGNUP: "/signup",
  RESET_PASSWORD: "api/v1/password-reset",
  ACCOUNT_SETUP: "/account-setup",
  EMAIL_ACTIVATION: "/activation",
  // Chat routes
  CHAT: "/messages/:conversationId",
  CHAT_INBOX: "/messages",
} as const;

// Type-safe route helper
export const createRoute = (
  template: string,
  params: Record<string, string>,
): string => {
  try {
    let route = template;
    Object.entries(params).forEach(([key, value]) => {
      if (typeof value === "string") {
        route = route.replace(`:${key}`, encodeURIComponent(value));
      }
    });
    return route;
  } catch (error) {
    console.error("Route creation error:", error);
    return template;
  }
};
